import React from 'react'

const GlobalContext = React.createContext({
  user: {},
  bootcampActive: {},
})

export default GlobalContext
